<!--
 * @Copyright: Copyright (c) 2021 Yihua, All right is reserverd
 * @name: FooterBar
 * @Description: 底部组件
 * @FilePath: /hugou-h5/src/components/FooterBar.vue
 * @Version: 0.1.0
 * @Autor: hselenat
 * @Date: 2021-04-28 14:52:11
 * @LastEditors: hselenat
 * @LastEditTime: 2021-04-29 13:10:40
 * @example: 调用示例
-->
<template>
  <footer class="footer-x">
    <div class="describe-image">
      <img :src="require('../assets/home_' + curEquip + '_' + describeData + '.png')" />
    </div>
    <div class="footer">
      <p class="link">
        <a href="https://app.tikfriend.com/protocol/hugou_privacy.html"
          >《互勾隐私政策》</a
        ><a href="https://app.tikfriend.com/protocol/hugou_userservice.html"
          >《用户服务协议》</a
        >
      </p>
      <p>
        <span class="copyright"
          >© 2016 - 2021 泉州砾石企业孵化服务有限公司 版权所有
        </span>
        <span class="icp"
          >|
          <a href="https://beian.miit.gov.cn/" target="_blank"
            >闽ICP备17029570号-2
          </a>
          <img src="../assets/icp_public.png" alt="闽公网" />
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35050202000187"
            target="_blank"
            >闽公网安备 35050202000187号</a
          ></span
        >
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterBar",
  props: {
    describeData: {
      typpe: String,
      default: 'chat'
    }
  },
  data() {
    return {
      curImg: '',
      curEquip: localStorage.getItem('curEquip')
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/FooterBar.vue